import React from "react";
import { Button, Result, Space } from "antd";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh',
      padding: 24
    }}>
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={
          <Space>
            <Button type="primary" onClick={() => nav("/")}>
              返回首页
            </Button>
            <Button onClick={() => nav(-1)}>
              返回上一页
            </Button>
          </Space>
        }
      />
    </div>
  );
}